import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { RadioOption, UiPlatformRadioComponent } from 'ui-platform';

@Component({
  selector: 'sh-platform-radio',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiPlatformRadioComponent
  ],
  templateUrl: './platform-radio.component.html',
  styleUrl: './platform-radio.component.scss'
})
export class PlatformRadioComponent {
  form = new FormGroup({
    carbonNeutral: new FormControl(true)
  });
  options: RadioOption[] = [
    {
      value: true,
      label: 'Carbon Neutral (Yes)'
    },
    {
      value: false,
      label: 'Carbon Negative (No)'
    }
  ];

  import = `
    import { UiPlatformRadioComponent, RadioOption } from 'ui-platform';
  `;

  usageCode = `
    form = new FormGroup({
      carbonNeutral: new FormControl(true)
    });
    options: RadioOption[] = [
      {
        value: true,
        label: "Carbon Neutral (Yes)"
      },
      {
        value: false,
        label: "Carbon Negative (No)"
      },
    ];
    `;

  usageTemplate = `
    <ui-platform-radio
      formControlName="carbonNeutral"
      [options]="options"
    ></ui-platform-radio>
  `;
}
